var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropboxDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 30,
    fill: "#0F287F",
    stroke: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.25 23L18 29.6176L29.25 36.2353L18 42.8529L29.25 49.4706L40.5 42.8529L51.75 49.4706L63 42.8529L51.75 36.2353L63 29.6176L51.75 23L40.5 29.6176L29.25 23ZM40.5 29.6176L51.75 36.2353L40.5 42.8529L29.25 36.2353L40.5 29.6176Z",
    fill: "#DAF8FE",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 53.8824L40.5 47.2647L51.75 53.8824L40.5 60.5L29.25 53.8824Z",
    fill: "#DAF8FE",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropboxDark);
export default __webpack_public_path__ + "static/media/dropbox-dark.3ec76eb774fb1e8fc810fec3bfb95722.svg";
export { ForwardRef as ReactComponent };